<template>
  <div class="f-ast f-v">
    <donut-loading-dots v-if="fetchingGiftCard" class="f-jc" />
    <div v-else class="t t-xl ta-c m-tx3 m-bx3">
      Spend <span v-emoji="`${giftCardPointsCost.toLocaleString()} ${config.points_name_plural} :${config.emoji}:`" class="bold" />
      to redeem a <span class="bold">{{ giftCardValue }} gift card</span>?
    </div>
    <donut-modal-sections-actions
      button-text="Redeem"
      save-mutation="updateExistingModal"
      :show-cancel="!fetchingGiftCard"
      :is-save-disabled="fetchingGiftCard"
      :save-args="saveArgs"
    />
  </div>
</template>

<script setup>
  import { computed, watch } from 'vue';
  import { useStore } from 'vuex';

  const { state, dispatch, getters } = useStore();

  const config = computed(() => state.pointsConfig.config);
  const listing = computed(() => state.modal.data.listing);
  const giftCardPointsCost = computed(() => state.modal.data.gift_card_points_cost);
  const centsPerPoint = computed(() => Math.round(state.pointsConfig.dollarsPerPoint * 100));
  const giftCardValue = computed(() => {
    const dollars = getters['rewardsListings/convertGiftCardPointsToDollars'](listing.value, giftCardPointsCost.value);
    return `$${dollars}`;
  });
  const fetchingGiftCard = computed(() => state.modal.data.fetchingGiftCard);

  const saveArgs = computed(() => ({
    dismissable: false,
    data: {
      ...state.modal.data,
      fetchingGiftCard: true,
    },
  }));

  const giftCardRedemptionArgs = computed(() => ({
    listing: listing.value,
    pointsConfig: config.value,
    gift_card_points_cost: giftCardPointsCost.value,
    cents_per_point: centsPerPoint.value,
  }));

  watch(fetchingGiftCard, (val) => {
    if (val) {
      dispatch('rewardsListings/redeemListing', giftCardRedemptionArgs.value);
    }
  });
</script>
